/* eslint-disable no-unused-vars */
// import {
//   useSessionList,
//   useTransactionLogsByTID,
// } from '../../../utils/queries/chargingSessions';
// import TransactionLogs from '../../Charger/TransactionLogs';
import { formatDate } from '../../../utils/dateUtils';
import { CSVLink } from 'react-csv';
import 'antd/dist/antd.css';
import {
  downloadCorporateSessions,
  useDownloadCorporateSessions,
  useFetchAllCorporateSessions,
  useFetchCorporateSessionListByEmailOrName,
} from '../../../utils/queries/corporateChargingSessions';
import { useStopCharging } from '../../../utils/queries/corporateChargingSessions';
import { useEffect, useRef, useState } from 'react';
import { Input } from 'reactstrap';
import {
  Table,
  Typography,
  Tag,
  Popover,
  Pagination,
  Badge,
  Button,
  message,
  AutoComplete,
} from 'antd';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { get, toNumber, filter as lodashFilter } from 'lodash-es';
import { JPDatePicker } from 'components/Reusable/JPDatePicker';
import moment from 'moment';
import { BsSearch } from 'react-icons/bs';
import { BsX } from 'react-icons/bs';
import { BsDownload } from 'react-icons/bs';
import { useGetCorporateUserSuggestionsByName } from 'utils/queries/corporateUsers';
import { useGetCorporateUserSuggestionsByEmail } from 'utils/queries/corporateUsers';

const { Text } = Typography;

const useStyles = createUseStyles({
  onlineOfflineBadgeIcon: {
    '& .ant-badge-status-dot': {
      height: '11px',
      width: '11px',
    },
  },
});

export default function CorporateChargingSessionsList({
  corporateId = '',
  filter,
}) {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [namesParam, setNamesParam] = useState([]);
  const [emailsParam, setEmailsParam] = useState([]);
  const [queryString, setQueryString] = useState('');
  const [enableDownload, setEnableDownload] = useState(false);
  const [enableSearch, setEnableSearch] = useState(true);
  const [searchedData, setSearchedData] = useState('');
  const [downloadableData, setDownloadableData] = useState('');
  const [nameOptions, setNameOptions] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);
  const [nameQuery, setNameQuery] = useState('');
  const [emailQuery, setEmailQuery] = useState('');
  const { data: userNames, isLoading: autoCompleteNameLoading } =
    useGetCorporateUserSuggestionsByName(nameQuery);
  const { data: userEmails, isLoading: autoCompleteEmailLoading } =
    useGetCorporateUserSuggestionsByEmail(emailQuery);
  // const {
  //   data: dataResult,
  //   isLoading,
  //   isError,
  //   refetch,
  //   isSuccess,
  // } = useFetchAllCorporateSessions({
  //   query: queryString,
  //   type: 'CUSTOMERS.ID',
  //   filter,
  //   offset: (currentPage - 1) * pageLimit,
  //   limit: pageLimit,
  //   startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
  //   endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
  //   corporateId,
  //   enableSearch,
  // });

  const {
    data: dataResult,
    isLoading,
    isError,
    refetch,
    isSuccess,
  } = useFetchCorporateSessionListByEmailOrName({
    query: queryString,
    type: 'CUSTOMERS.ID',
    filter,
    offset: (currentPage - 1) * pageLimit,
    limit: pageLimit,
    startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
    endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
    names: namesParam,
    emails: emailsParam,
    corporateId,
    enableSearch,
  });

  const {
    data,
    isLoading: isLoadingDownload,
    isError: isErrorDownload,
    isSuccess: isSuccessDownload,
    refetch: refetchDownload,
  } = useDownloadCorporateSessions({
    query: queryString,
    type: 'CUSTOMERS.ID',
    filter,
    offset: 0,
    //limit: searchedData?.total,
    limit: dataResult?.total,
    startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
    endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
    names: namesParam,
    emails: emailsParam,
    corporateId,
    enableDownload,
  });

  useEffect(() => {
    if (userNames?.data?.length > 0) {
      const uNames = [];
      userNames?.data?.forEach((v) => {
        uNames.push({
          value: v,
          key: v,
        });
      });
      setNameOptions(uNames);
    }
  }, [userNames]);

  useEffect(() => {
    if (userEmails?.data?.length > 0) {
      const uEmails = [];
      userEmails?.data?.forEach((v) => {
        uEmails.push({
          value: v,
          key: v,
        });
      });
      setEmailOptions(uEmails);
    }
  }, [userEmails]);

  useEffect(() => {
    if (dataResult?.list?.length > 0) {
      setSearchedData(dataResult);
      setTimeout(() => {
        setEnableDownload(true);
      }, [1000]);
    } else if (dataResult?.error) {
      message.error(dataResult?.error);
      setTimeout(() => message.destroy(), 3000);
    }
  }, [dataResult]);

  useEffect(() => {
    if (isError || isSuccess) {
      //setEnableSearch(false);
    }
  }, [isError, isSuccess]);

  useEffect(() => {
    if (isErrorDownload || isSuccessDownload) {
      setTimeout(() => {
        setEnableDownload(false);
      }, [500]);
    }
  }, [isErrorDownload, isSuccessDownload, data]);

  const [transactionRequest, setTransactionRequest] = useState({
    cpid: '',
    tid: '',
  });
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (data?.list?.length > 0) {
      generate(data);
    }
  }, [data]);

  function onSearch(queryString) {
    setQueryString(queryString);
    setCurrentPage(1);
  }

  const generate = (dataArr) => {
    if (!dataArr?.list?.length > 0) return '';
    const meta = [
      {
        label: 'TRANSACTION ID',
        dataIndex: 'TRANSACTIONID',
        customValue: (session) => {
          return session?.TRANSACTIONID?.toString();
        },
      },
      {
        label: 'Charger Type',
        dataIndex: 'CHARGERS.IS_DC',
        customValue: (session) => {
          return get(session, 'CHARGERS.IS_DC') ? 'DC' : 'AC';
        },
      },
      {
        label: 'Vehicle Type',
        dataIndex: 'CHARGERS.VEHICLE_TYPE',
        customValue: (session) => {
          return get(session, 'CHARGERS.VEHICLE_TYPE') === '4'
            ? 'Four Wheeler'
            : 'Two Wheeler';
        },
      },
      {
        label: 'VIN',
        dataIndex: 'IDTAG',
        customValue: (session) => {
          return get(session, 'IDTAG')
        },
      },
      {
        label: 'Vehicle Number',
        dataIndex: 'VEHICLE_NUMBER',
        customValue: (session) => {
          return get(session, 'VEHICLE_NUMBER')
        },
      },
      {
        label: 'SUPPLIER NAME',
        dataIndex: 'SUPPLIER_NAME',
        customValue: (session) => {
          return get(session, 'SUPPLIER_NAME')
        },
      },
      {
        label: 'PLANT NAME',
        dataIndex: 'PLANT_NAME',
        customValue: (session) => {
          return get(session, 'CHARGERS.CITY')
        },
      },
      {
        label: 'Connector Type',
        dataIndex: 'CHARGERS.TYPE',
        customValue: (session) => {
          return get(session, 'CP_CONNECTORS.TYPE');
        },
      },
      {
        label: 'ENERGY CONSUMED',
        dataIndex: 'KWH_CONSUMED',
        customValue: (session) => {
          return session?.KWH_CONSUMED
            ? toNumber(session?.KWH_CONSUMED)?.toFixed(2) + 'kWh'
            : 0;
        },
      },
      {
        label: 'CO2 EMISSION SAVED',
        dataIndex: 'CO2_EMISSION_SAVED',
        customValue: (session) => {
          return session?.CO2_EMISSION_SAVED
            ? toNumber(session?.CO2_EMISSION_SAVED)?.toFixed(2) + ' Kg'
            : 0;
        },
      },
      {
        label: 'TREES SAVED',
        dataIndex: 'TREES_SAVED',
        customValue: (session) => {
          return session?.TREES_SAVED ? session?.TREES_SAVED : 0;
        },
      },
      {
        label: 'PHONE NUMBER',
        dataIndex: 'CUSTOMERS.PHONE_NUMBER',
        customValue: (session) => {
          return session['CUSTOMERS.PHONE_NUMBER'].toString();
        },
      },
      {
        label: 'Name',
        dataIndex: 'CUSTOMERS.NAME',
        customValue: (session) => {
          return session['CUSTOMERS.NAME'];
        },
      },
      {
        label: 'Email',
        dataIndex: 'CUSTOMERS.EMAIL',
        customValue: (session) => {
          return session['CUSTOMERS.EMAIL'];
        },
      },
      {
        label: 'CHARGER ID',
        dataIndex: 'CPID',
        customValue: (session) => session?.CPID,
      },
      {
        label: 'LOCATION',
        dataIndex: 'JP_CORPORATE_LOCATION.NAME',
        customValue: (session) => session['JP_CORPORATE_LOCATION.NAME'],
      },
      {
        label: 'CONNECTOR',
        dataIndex: 'CONNECTORID',
        customValue: (session) => session?.CONNECTORID?.toString(),
      },
      {
        label: 'Stop Transaction Reason',
        dataIndex: 'REASON',
        customValue: (session) => session?.REASON,
      },
      {
        label: 'STARTED AT',
        dataIndex: 'START_TIME',
        customValue: (session) =>
          session?.START_TIME ? formatDate(session?.START_TIME) : '',
      },
      {
        label: 'ENDED AT',
        dataIndex: 'END_TIME',
        customValue: (session) =>
          session?.END_TIME ? formatDate(session?.END_TIME) : '',
      },
    ];

    let dataString = [];
    let headers = ['S.NO.'];
    meta.forEach((m) => {
      headers.push(`${m.label}`);
    });
    dataString.push(headers);

    let energyConsumedTotal = 0;
    let co2EmissionSavedTotal = 0;
    let treeSavedTotal = 0;
    dataArr?.list?.forEach((row, index) => {
      let rowItem = [];
      rowItem.push(`${index + 1}`);
      meta.forEach((m) => {
        rowItem.push(m.customValue ? m.customValue(row) : '');
      });
      energyConsumedTotal =
        energyConsumedTotal + Math.round(row?.KWH_CONSUMED * 100) / 100;
      co2EmissionSavedTotal =
        co2EmissionSavedTotal + Math.round(row?.CO2_EMISSION_SAVED * 100) / 100;
      treeSavedTotal = treeSavedTotal + row?.TREES_SAVED ? row?.TREES_SAVED : 0;
      dataString.push(rowItem);
    });

    let footer = ['Total:'];
    meta.forEach((m) => {
      // m.label === 'ENERGY CONSUMED'
      //   ? footer.push(`${energyConsumedTotal?.toFixed(2)}kWh`)
      //   : footer.push('');
      if (m.label === 'ENERGY CONSUMED')
        footer.push(`${energyConsumedTotal?.toFixed(2)}kWh`);
      else if (m.label === 'CO2 EMISSION SAVED')
        footer.push(`${co2EmissionSavedTotal?.toFixed(2)} kg`);
      else if (m.label === 'TREES SAVED') footer.push(`${treeSavedTotal}`);
      else footer.push('');
    });
    dataString.push(footer);
    setDownloadableData(dataString);
  };

  /* **** Stop Charging States ***** */
  const initiateStopCharging = useStopCharging();

  // eslint-disable-next-line consistent-return
  async function stopCharging(queueId) {
    try {
      const result = await initiateStopCharging.mutateAsync({
        queueId,
      });
      refetch();
      message.success(result?.resData?.status);
      setTimeout(() => message.destroy(), 3000);
    } catch (error) {
      message.error(
        `Oops something went wrong: ${error?.response?.resData?.message}`,
      );
      setTimeout(() => message.destroy(), 3000);
    }
  }

  const columns = [
    {
      title: 'Transaction ID',
      dataIndex: 'TRANSACTIONID',
      render: (text, session) => {
        const isSessionActive = session?.START_TIME && !session?.END_TIME;
        return (
          <>
            <Badge
              status={isSessionActive ? 'processing' : 'error'}
              color={isSessionActive ? '#52c41a' : '#f94d4f'}
              className={classes.onlineOfflineBadgeIcon}
            />
            <Link to={`/corporate/session/${session?.QUEUEID}`}>
              {session?.TRANSACTIONID}
            </Link>
          </>
        );
      },
      key: 'TRANSACTIONID',
      width: 200,
    },
    {
      title: 'Charger Type',
      dataIndex: 'CHARGER_TYPE',
      render: (name, session) => (
        <>
          <Text>{get(session, 'CHARGERS.IS_DC') ? 'DC' : 'AC'}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 50,
    },
    {
      title: 'Vehicle Type',
      dataIndex: 'VEHICLE_TYPE',
      render: (name, session) => (
        <>
          <Text>
            {get(session, 'CHARGERS.VEHICLE_TYPE') === '4'
              ? 'Four Wheeler'
              : 'Two Wheeler'}
          </Text>
        </>
      ),
      key: 'QUEUEID',
      width: 50,
    },
    {
      title: 'VIN',
      dataIndex: 'IDTAG',
      render: (name, session) => (
        <>
          <Text>{get(session, 'IDTAG')}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 50,
    },
    {
      title: 'Vehicle Number',
      dataIndex: 'VEHICLE_NUMBER',
      render: (name, session) => (
        <>
          <Text>{get(session, 'VEHICLE_NUMBER')}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 100,
    },
    {
      title: 'SUPPLIER NAME',
      dataIndex: 'SUPPLIER_NAME',
      render: (name, session) => (
        <>
          <Text>{get(session, 'SUPPLIER_NAME')}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 100,
    },
    {
      title: 'PLANT NAME',
      dataIndex: 'PLANT_NAME',
      render: (name, session) => (
        <>
          <Text>{get(session, 'CHARGERS.CITY')}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 100,
    },
    {
      title: 'Connector Type',
      dataIndex: 'TYPE',
      render: (name, session) => (
        <>
          <Text>{get(session, 'CP_CONNECTORS.TYPE')}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 50,
    },
    {
      title: 'Energy Consumed',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text>
            {session?.KWH_CONSUMED
              ? `${toNumber(session?.KWH_CONSUMED)?.toFixed(2)} kWh`
              : '-'}
          </Text>
        </>
      ),
      key: 'QUEUEID',
      width: 150,
    },
    {
      title: 'CO2 Emission Saved',
      dataIndex: 'CO2_EMISSION_SAVED',
      render: (name, session) => (
        <>
          <Text>
            {session?.CO2_EMISSION_SAVED
              ? toNumber(session?.CO2_EMISSION_SAVED)?.toFixed(2) + ' Kg'
              : '-'}
          </Text>
        </>
      ),
      key: 'QUEUEID',
      width: 100,
    },
    {
      title: 'Trees Saved',
      dataIndex: 'TREES_SAVED',
      render: (name, session) => (
        <>
          <Text>{session?.TREES_SAVED ? session?.TREES_SAVED : '-'}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 50,
    },
    {
      title: 'Phone Number',
      dataIndex: 'PHONE_NUMBER',
      render: (name, session) => (
        <>
          <Text>{get(session, 'CUSTOMERS.PHONE_NUMBER') || '-'}</Text>
        </>
      ),
      key: 'PHONE_NUMBER',
      width: 150,
    },
    {
      title: 'Name',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text> {get(session, 'CUSTOMERS.NAME')}</Text>
        </>
      ),
      key: 'QUEUEID',
      // width: 100,
    },
    {
      title: 'Email',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text> {get(session, 'CUSTOMERS.EMAIL')}</Text>
        </>
      ),
      key: 'QUEUEID',
      //width: 100,
    },
    {
      title: 'Charger Id',
      dataIndex: 'CPID',
      render: (name, cp) => (
        <>
          <Link
            to={`/corporate/charger/detail/${get(
              cp,
              'JP_CORPORATE_LOCATION.JP_CORPORATE',
            )}/${get(cp, 'ID')}/${get(cp, 'JP_CORPORATE_CHARGER.ID')}`}
          >
            {cp?.CPID}
          </Link>
        </>
      ),
      key: 'CPID',
      width: 160,
    },
    {
      title: 'Location',
      dataIndex: 'JP_CORPORATE_LOCATION.NAME',
      render: (name, session) => (
        <>
          <Text> {get(session, 'JP_CORPORATE_LOCATION.NAME')}</Text>
        </>
      ),
      key: 'JP_CORPORATE_LOCATION.NAME',
      width: 150,
    },
    {
      title: 'Connector',
      dataIndex: 'CONNECTORID',
      render: (name, session) => <>{session?.CONNECTORID}</>,
      width: 110,
      key: 'CONNECTORID',
      align: 'center',
    },
    {
      title: 'Stop Transaction Reason',
      dataIndex: 'REASON',
      render: (name, session) => <>{get(session, 'REASON')}</>,
      width: 110,
      key: 'REASON',
      align: 'center',
    },
    {
      title: 'Started at',
      dataIndex: 'START_TIME',
      render: (name, session) => <>{formatDate(session?.START_TIME)}</>,
      key: 'START_TIME',
      width: 170,
    },
    {
      title: 'Ended at',
      dataIndex: 'END_TIME',
      render: (name, session) => (
        <>
          {session?.END_TIME ? (
            formatDate(session?.END_TIME)
          ) : (
            <Button
              type="primary"
              size="large"
              onClick={() => stopCharging(session?.QUEUEID)}
              loading={initiateStopCharging.isLoading}
            >
              Stop Charging
            </Button>
          )}
        </>
      ),
      key: 'END_TIME',
      width: 170,
      // hidden: filter === 'active',
    },
  ].filter((item) => !item.hidden);

  function onPageSizeChange(newPageSize) {
    setPageLimit(newPageSize);
  }

  const onChangeName = (queryString) => {
    if (queryString) {
      if (queryString?.length >= 3) {
        setNameQuery(queryString);
      }
    } else {
      setNameQuery('');
      setNameOptions([]);
      setNamesParam([]);
    }
  };

  const onChangeEmail = (queryString) => {
    if (queryString) {
      if (queryString?.length >= 3) {
        setEmailQuery(queryString);
      }
    } else {
      setEmailQuery('');
      setEmailOptions([]);
      setEmailQuery([]);
    }
  };

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <JPDatePicker
          label="Start Date"
          setter={setStartDate}
          style={{ margin: '0px 5px' }}
          val={startDate}
        />
        <JPDatePicker
          label="End Date"
          setter={setEndDate}
          style={{ margin: '0px 5px' }}
          val={endDate}
        />
        <div style={{ margin: '0px 5px' }}>
          <div>Name</div>
          <AutoComplete
            options={nameOptions}
            name="Names"
            style={{ width: 200 }}
            onChange={(value) => onChangeName(value)}
            onSelect={(value, option) => {
              const namesArr = [value];
              setNamesParam(namesArr);
            }}
            placeholder=""
            mode="tags"
          />
        </div>
        <div style={{ margin: '0px 5px' }}>
          <div>Email</div>
          <AutoComplete
            options={emailOptions}
            name="Emails"
            style={{ width: 200 }}
            onChange={(value) => onChangeEmail(value)}
            onSelect={(value, option) => {
              const emailsArr = [value];
              setEmailsParam(emailsArr);
            }}
            placeholder=""
            mode="tags"
          />
        </div>

        {(startDate ||
          endDate ||
          namesParam?.length > 0 ||
          emailsParam?.length > 0 ||
          queryString) && (
          <BsX
            style={{
              marginLeft: 15,
              marginTop: 15,
              fontSize: 25,
              color: '#414141',
              cursor: 'pointer',
            }}
            title="Reset"
            onClick={() => {
              // resetSearch();
              window.location.reload(false);
            }}
          />
        )}
        <Button
          onClick={() => {
            setEnableSearch(true);
          }}
          style={{
            backgroundColor: '#2675b8 !important',
            height: 35,
            // float: 'right',
            background: '#2675b8',
            color: 'white',
            fontSize: '14px',
            borderRadius: '5px',
            padding: '6px 10px',
            margin: '20px 5px 0px 20px',
          }}
        >
          <BsSearch style={{ marginRight: 5 }}></BsSearch> Search
        </Button>
      </div>

      {searchedData?.total > 0 && (
        <CSVLink
          data={downloadableData}
          filename="CorporateSessions.csv"
          separator=","
          className="csv-button"
          style={{
            backgroundColor: '#2675b8 !important',
            height: 35,
            // float: 'right',
            background: '#2675b8',
            color: 'white',
            fontSize: '14px',
            borderRadius: '5px',
            padding: '6px',
            marginTop: 20,
          }}
        >
          <BsDownload style={{ margin: '0 5px' }}></BsDownload>Export as CSV
        </CSVLink>
      )}
    </div>
  );

  return (
    <>
      <Table
        rowKey="TRANSACTIONID"
        columns={columns}
        // dataSource={
        //   filteredData?.length > 0 ? filteredData : searchedData?.list
        // }
        dataSource={dataResult?.list}
        loading={isLoading}
        pagination={{
          current: currentPage,
          defaultCurrent: 1,
          defaultPageSize: pageLimit,
          pageSize: pageLimit,
          pageSizeOptions: [10, 20, 50, 100],
          total: searchedData?.total,
          showTotal: (total) => `Total ${total} records`,
          onShowSizeChange: (current, size) => {
            onPageSizeChange(size);
          },
          onChange: (pageNo) => {
            setCurrentPage(pageNo);
            setTimeout(() => {
              refetch();
            }, 300);
          },
        }}
        // footer={() => getFooter()}
        title={() => getTitle()}
        scroll={{ x: 1500 }}
      />
    </>
  );
}
